import React, { Component } from "react"
import { Row, Col } from "antd"
import ReportChart from "app/components/normal/ReportChart"
import { observer, inject } from "mobx-react"

const TYPE = [{
  name: "count",
  title: "数据总量",
  unit: "条数",
  color: ["#87c5ff", "rgba(135, 197, 255, 0.2)"]
}, {
  name: "size",
  title: "总资源占用",
  unit: "GB",
  color: ["#ace1b7", "rgba(172, 225, 183, 0.2)"]
}, {
  name: "report",
  title: "报告总量",
  unit: "个数",
  color: ["#ffcd66", "rgba(255, 205, 102, 0.2)"]
}]

@inject("store")@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getChartData()
  }

  render() {
    const { store: { chartData } } = this.props

    return (
      <Row className="dashboard-chart-list">
        {TYPE.map((item, index) => {
          return (
            <Col span={8} key={index}>
              <ReportChart
                data={chartData[item.name]}
                type={item}
              />
            </Col>
          )
        })}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/dashboard/containers/DataChart.js